import { css } from "@emotion/css";
import { MOBILE_NAV_HEIGHT } from "@sharpana/shared/layout";

export const authContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  padding: 20px;
`;

export const linkTextCompact = css`
  text-align: center;
  margin-top: 0.7rem;
  margin-bottom: 0.7rem;
  line-height: 1.2;
  a {
    color: #6ab0f3;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

// Viewport wrapper for RN WebView: reserves top overlay and bottom nav, centers content on large screens
export const authViewportMobile = css`
  display: grid;
  place-items: center;
  width: 100%;
  /* Occupy the full viewport height; padding carves out overlay and nav space */
  height: 100dvh;
  position: fixed;
  inset: 0;
  box-sizing: border-box;
  padding-top: clamp(200px, 37vh, 470px);
  padding-bottom: calc(${MOBILE_NAV_HEIGHT} + env(safe-area-inset-bottom, 0px));
  overflow: hidden; /* prevent page scroll; keep scroll inside card */
  overscroll-behavior: contain;
`;

// Login uses a slightly taller RN overlay; reserve a bit more space
export const authViewportMobileLogin = css`
  display: grid;
  place-items: center;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  height: 100dvh;
  position: fixed;
  inset: 0;
  box-sizing: border-box;
  padding-top: clamp(200px, 45vh, 520px);
  padding-bottom: calc(${MOBILE_NAV_HEIGHT} + env(safe-area-inset-bottom, 0px));
  overflow: hidden;
  overscroll-behavior: contain;
`;

// Signup overlay is a bit shorter; reserve slightly less space
export const authViewportMobileSignup = css`
  display: grid;
  place-items: center;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  height: 100dvh;
  position: fixed;
  inset: 0;
  box-sizing: border-box;
  padding-top: clamp(200px, 37vh, 500px);
  padding-bottom: calc(${MOBILE_NAV_HEIGHT} + env(safe-area-inset-bottom, 0px));
  overflow: hidden;
  overscroll-behavior: contain;
`;

export const authCard = css`
  background: #1e1e1e;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 400px;

  h1,
  h2,
  h3 {
    text-align: center;
    margin-bottom: 1.5rem;
    color: #e0e0e0;
  }
`;

export const authCardMobile = css`
  /* Mobile card is centered inside authViewportMobile and fills available space */
  width: 100%;
  max-width: 400px;
  max-height: 100%;
  margin: 6px 0;

  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  padding: 0.5rem 0.75rem;
  // box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.3);
  // background: #1e1e1e;
  overflow-y: auto;
  overscroll-behavior: contain;
  scroll-behavior: smooth;
`;

export const formGroup = css`
  margin-bottom: 1.5rem;
  width: 100%;

  label {
    display: block;
    margin-bottom: 0.5rem;
    color: #b0b0b0;
  }

  input {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #444;
    border-radius: 6px;
    font-size: 1rem;
    background-color: #2a2a2a;
    color: #e0e0e0;

    &:focus {
      outline: none;
      border-color: #6ab0f3;
      box-shadow: 0 0 0 2px rgba(106, 176, 243, 0.2);
    }
  }
`;

export const compactFormGroup = css`
  ${formGroup}
  margin-bottom: 0.8rem;
  label {
    margin-bottom: 0.4rem;
  }
  input {
    padding: 0.6rem;
    font-size: 0.95rem;
  }
`;

export const linkText = css`
  text-align: center;
  margin: 1rem 0;

  a {
    color: #6ab0f3;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const forgotPasswordLink = css`
  display: block;
  text-align: right;
  color: #6ab0f3;
  text-decoration: none;
  font-size: 0.9rem;
  margin: 0.5rem 0;

  &:hover {
    text-decoration: underline;
  }
`;

export const forgotPasswordLinkCompact = css`
  display: block;
  text-align: right;
  color: #6ab0f3;
  text-decoration: none;
  font-size: 0.85rem;
  margin: 0.25rem 0 0.5rem;
  &:hover {
    text-decoration: underline;
  }
`;
